export default __webpack_public_path__ + "static/media/bella-ramsey_6.2c9a5cab.jpg";